<div class="mt-3">
  <kl-ai-predictions-send-sms></kl-ai-predictions-send-sms>
</div>
